import { ERC20Token, ChainId, WBIT } from '@pancakeswap/sdk';

// src/common.ts
var MAMA_MAINNET = new ERC20Token(
  ChainId.MANTLE,
  "0xf6762afb45ac0af7ddc5aa92b885c6ece57874dc",
  18,
  "MAMA",
  "MAMA Token",
  "https://pancakeswap.finance/"
);
var MAMA_TESTNET = new ERC20Token(
  ChainId.MANTLE_TESTNET,
  "0xf6762afb45ac0af7ddc5aa92b885c6ece57874dc",
  18,
  "MAMA",
  "MAMA Token",
  "https://pancakeswap.finance/"
);
var USDC_MANTLE = new ERC20Token(
  ChainId.MANTLE,
  "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9",
  6,
  "USDC",
  "USD Coin",
  "https://www.centre.io/usdc"
);
var USDC_MANTLE_TESTNET = new ERC20Token(
  ChainId.MANTLE_TESTNET,
  "0xacab8129e2ce587fd203fd770ec9ecafa2c88080",
  6,
  "USDC",
  "USD Coin",
  "https://www.centre.io/usdc"
);
var MAMA = {
  [ChainId.MANTLE]: MAMA_MAINNET,
  [ChainId.MANTLE_TESTNET]: MAMA_TESTNET
};
var USDC = {
  [ChainId.MANTLE]: USDC_MANTLE,
  [ChainId.MANTLE_TESTNET]: USDC_MANTLE_TESTNET
  // [ChainId.MANTLE]: USDC_BSC,
  // [ChainId.MANTLE_TESTNET]: USDC_TESTNET,
  // [ChainId.ETHEREUM]: USDC_ETH,
  // [ChainId.GOERLI]: USDC_GOERLI,
};
var STABLE_COIN = {
  [ChainId.MANTLE_TESTNET]: USDC[ChainId.MANTLE_TESTNET],
  [ChainId.MANTLE]: USDC[ChainId.MANTLE]
  // [ChainId.ETHEREUM]: USDT[ChainId.ETHEREUM],
  // [ChainId.GOERLI]: USDC[ChainId.GOERLI],
  // [ChainId.MANTLE]: USDT[ChainId.MANTLE],
  // [ChainId.MANTLE_TESTNET]: BUSD[ChainId.MANTLE_TESTNET],
};
var EMPTY_LIST = {
  // [ChainId.ETHEREUM]: {},
  // [ChainId.GOERLI]: {},
  // [ChainId.MANTLE]: {},
  // [ChainId.MANTLE_TESTNET]: {},
  [ChainId.MANTLE]: {},
  [ChainId.MANTLE_TESTNET]: {}
};
function serializeTokens(unserializedTokens) {
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: unserializedTokens[key].serialize };
  }, {});
  return serializedTokens;
}
var mantleTokens = {
  mama: MAMA_MAINNET,
  wbit: WBIT[ChainId.MANTLE],
  // bnb here points to the wbnb contract. Wherever the currency BNB is required, conditional checks for the symbol 'BNB' can be used
  bit: new ERC20Token(ChainId.MANTLE, "0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000", 18, "MNT", "MNT", ""),
  usdt: new ERC20Token(ChainId.MANTLE, "0x201EBa5CC46D216Ce6DC03F6a759e8E766e956aE", 6, "USDT", "Tether USD", ""),
  usdc: new ERC20Token(
    ChainId.MANTLE,
    "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9",
    6,
    "USDC",
    "Binance-Peg USD Coin",
    "https://www.centre.io/usdc"
  ),
  wbtc: new ERC20Token(
    ChainId.MANTLE,
    "0xcabae6f6ea1ecab08ad02fe02ce9a44f09aebfa2",
    8,
    "WBTC",
    "Wrapped BTC",
    ""
  ),
  weth: new ERC20Token(
    ChainId.MANTLE,
    "0xdEAddEaDdeadDEadDEADDEAddEADDEAddead1111",
    18,
    "WETH",
    "ETHER",
    ""
  ),
  mETH: new ERC20Token(
    ChainId.MANTLE,
    "0xcda86a272531e8640cd7f1a92c01839911b90bb0",
    18,
    "mETH",
    "mETH",
    ""
  ),
  cmETH: new ERC20Token(
    ChainId.MANTLE,
    "0xe6829d9a7ee3040e1276fa75293bde931859e8fa",
    18,
    "cmETH",
    "cmETH",
    ""
  ),
  USDY: new ERC20Token(
    ChainId.MANTLE,
    "0x5be26527e817998a7206475496fde1e68957c5a6",
    18,
    "USDY",
    "Ondo U.S. Dollar Yield",
    ""
  ),
  USDe: new ERC20Token(
    ChainId.MANTLE,
    "0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34",
    18,
    "USDe",
    "USDe",
    ""
  ),
  USDT0: new ERC20Token(
    ChainId.MANTLE,
    "0x779Ded0c9e1022225f8E0630b35a9b54bE713736",
    6,
    "USDT0",
    "USDT0",
    ""
  )
};
var mantleTestnetTokens = {
  wbit: WBIT[ChainId.MANTLE_TESTNET],
  // bnb here points to the wbnb contract. Wherever the currency BNB is required, conditional checks for the symbol 'BNB' can be used
  bit: new ERC20Token(
    ChainId.MANTLE_TESTNET,
    "0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF",
    18,
    "MNT",
    "MNT",
    "https://www.binance.com/"
  ),
  mama: MAMA_TESTNET,
  usdc: new ERC20Token(
    ChainId.MANTLE_TESTNET,
    "0xacab8129e2ce587fd203fd770ec9ecafa2c88080",
    6,
    "USDC",
    "Binance-Peg USD Coin",
    "https://www.centre.io/usdc"
  ),
  doge: new ERC20Token(ChainId.MANTLE_TESTNET, "0x3edb12e9cf43a6f645eedee2800e01e142c5758d", 18, "DOGE", "Doge", ""),
  usdt: new ERC20Token(ChainId.MANTLE_TESTNET, "0xcc4ac915857532ada58d69493554c6d869932fe6", 6, "USDT", "USDT", "")
};

export { EMPTY_LIST, MAMA, MAMA_MAINNET, MAMA_TESTNET, STABLE_COIN, USDC, USDC_MANTLE, USDC_MANTLE_TESTNET, mantleTestnetTokens, mantleTokens, serializeTokens };
